export const BELGIAN_REGISTER_NUMBER_PATTERN = /^\d{2}(\.\d{2})(\.\d{2})-\d{3}\.\d{2}$/;
